import React, { useCallback, useMemo, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useToast } from "hooks/useToast";
import { useTransaction } from "hooks/useTransaction";
import { Margin } from "interfaces/data";
import { MarginFormModal } from "views/Margin/MarginFormModal/MarginFormModal";

export function MarginEditLocal() {
  const history = useHistory();
  const { t } = useTranslation();
  const { id, transactionId, marginId } = useParams<{
    id: string;
    transactionId: string;
    marginId: string;
  }>();
  const toast = useToast();
  const { transaction, marginUpdate, marginErrors } = useTransaction({
    id: transactionId,
  });
  const [isSending, setIsSending] = useState(false);

  const handleClose = useCallback(() => {
    history.push(`/companies/${id}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const editedMargin = useMemo(
    () => transaction?.margins?.find((margin) => margin.id === marginId),
    [marginId, transaction]
  );

  const handleOnSaveAction = useCallback(
    (newMargin: Margin) => {
      setIsSending(true);
      marginUpdate(newMargin)
        .then((isSaved) => {
          setIsSending(false);
          if (isSaved) {
            toast({
              type: "success",
              message: t("margin:Margin have been updated successfully."),
            });
            handleClose();
          }
        })
        .catch((error) => {
          setIsSending(false);
          toast({
            type: "error",
            message: t(`margin:${error.message}`),
          });
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [marginUpdate, history, id, editedMargin]
  );

  if (!editedMargin) return null;

  return (
    <MarginFormModal
      errors={marginErrors}
      initialMargin={editedMargin}
      isDisabled={isSending}
      onClose={handleClose}
      onSave={handleOnSaveAction}
      title={t("margin:Edit margin {{marginId}}", { marginId: marginId })}
      type="edit"
    />
  );
}
